export const INVOICE_TYPES = [
  { id: '0', value: 'Selecione uma opção' },
  { id: 'ATRASADO', value: 'Faturas em atraso' },
  { id: 'FUTURAS', value: 'Faturas Futuras' },
  { id: 'EMITIDAS', value: 'Faturas Emitidas' },
  { id: 'FECHAMENTO', value: 'Fechamento Ciclos' },
];
